import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, CreditCard, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-8 md:pt-32 md:pb-24 overflow-hidden bg-neutral-950" data-id="element-137">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-red-900/40 via-neutral-950 to-neutral-950" data-id="element-138"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-139">
        <div className="max-w-4xl mx-auto text-center" data-id="element-140">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-141">
            <span className="inline-block py-1 px-3 rounded-full bg-red-600/20 text-red-400 font-semibold text-xs md:text-sm mb-3 md:mb-6 border border-red-500/30" data-id="element-142">
              Megapack Ritmos Latinos Resuelto
            </span>
            <h1 className="text-3xl md:text-6xl lg:text-7xl font-black text-white mb-4 md:mb-6 leading-tight tracking-tight" data-id="element-143">
              Todo tu año de{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-red-500" data-id="element-144">
                Ritmos Latinos
              </span>{' '}
              resuelto.
            </h1>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="mb-4 md:mb-8" data-id="element-145">
              <img src="https://cdn.magicpatterns.com/uploads/9anvZP48JHLsHoce5pAbi7/mockup_ritmos_latinos.png" alt="Megapack Ritmos Latinos Resuelto" className="w-[60%] md:w-[70%] mx-auto drop-shadow-2xl" data-id="element-146" />
            </motion.div>

            <p className="text-lg md:text-2xl text-neutral-300 mb-2 md:mb-4 font-medium" data-id="element-147">
              6 Tomos · 60+ Recursos · 6 Bonos · Listo para usar.
            </p>
            <p className="text-sm md:text-lg text-neutral-400 mb-6 md:mb-10 max-w-2xl mx-auto leading-snug" data-id="element-148">
              Tu año completo de clases de ritmos latinos listo: coreografías,
              técnica, progresión, planificación, gestión y negocio. Sin
              improvisar.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col items-center" data-id="element-149">
            <div className="flex flex-wrap justify-center items-center gap-3 text-xs md:text-sm text-neutral-400 mb-4 md:mb-6 font-medium" data-id="element-150">
              <span className="flex items-center gap-1" data-id="element-151">
                <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-amber-500" data-id="element-152" />{' '}
                PDF Digital
              </span>
              <span className="flex items-center gap-1" data-id="element-153">
                <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-amber-500" data-id="element-154" />{' '}
                Acceso Inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-155">
                <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-amber-500" data-id="element-156" />{' '}
                Todos los niveles
              </span>
            </div>

            <a href="#pricing" className="group relative inline-flex items-center justify-center px-6 py-4 md:px-8 md:py-5 text-base md:text-lg font-bold text-white transition-all duration-200 bg-gradient-to-r from-red-600 to-red-800 rounded-xl hover:from-red-500 hover:to-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600 focus:ring-offset-neutral-900 w-full md:w-auto shadow-[0_0_40px_rgba(220,38,38,0.4)] hover:shadow-[0_0_60px_rgba(220,38,38,0.6)] hover:-translate-y-1" data-id="element-157">
              💥 QUIERO MI RITMOS LATINOS RESUELTO AHORA →
            </a>

            <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 mt-5 md:mt-8 text-xs md:text-sm text-neutral-400" data-id="element-158">
              <span className="flex items-center gap-1" data-id="element-159">
                <ShieldCheck className="w-3.5 h-3.5" data-id="element-160" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-161">
                <ShieldCheck className="w-3.5 h-3.5" data-id="element-162" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-163">
                <CreditCard className="w-3.5 h-3.5" data-id="element-164" /> Mercado Pago | Tarjeta
              </span>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="border-y border-neutral-800 bg-neutral-900/50 mt-8 md:mt-16 backdrop-blur-sm" data-id="element-165">
        <div className="container mx-auto px-4 py-4 md:py-6" data-id="element-166">
          <div className="grid grid-cols-4 gap-2 md:flex md:flex-wrap md:justify-center md:gap-16 text-center" data-id="element-167">
            <div data-id="element-168">
              <div className="text-lg md:text-2xl font-bold text-white mb-0.5" data-id="element-169">
                +500
              </div>
              <div className="text-[10px] md:text-sm text-neutral-400 font-medium" data-id="element-170">
                Profes Confían
              </div>
            </div>
            <div data-id="element-171">
              <div className="text-lg md:text-2xl font-bold text-white mb-0.5" data-id="element-172">
                6+6
              </div>
              <div className="text-[10px] md:text-sm text-neutral-400 font-medium" data-id="element-173">
                Tomos + Bonos
              </div>
            </div>
            <div data-id="element-174">
              <div className="text-lg md:text-2xl font-bold text-white mb-0.5 flex items-center justify-center gap-1" data-id="element-175">
                4.9{' '}
                <Star className="w-4 h-4 md:w-5 md:h-5 text-amber-400 fill-amber-400" data-id="element-176" />
              </div>
              <div className="text-[10px] md:text-sm text-neutral-400 font-medium" data-id="element-177">
                Calificación
              </div>
            </div>
            <div data-id="element-178">
              <div className="text-lg md:text-2xl font-bold text-white mb-0.5" data-id="element-179">
                🇦🇷
              </div>
              <div className="text-[10px] md:text-sm text-neutral-400 font-medium" data-id="element-180">
                Todo el país
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}